/**
 * DUFFTIE GSAP Animation Controller
 * Handles all scroll-triggered animations on the homepage.
 */
(function () {
  function init() {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!document.querySelector('.df-homepage')) return;

    gsap.registerPlugin(ScrollTrigger);

    // ─── Hero Animations ───
    const hero = document.querySelector('.df-hero');
    if (hero) {
      const tl = gsap.timeline({ defaults: { ease: 'power3.out' } });

      tl.to('.df-hero__media img, .df-hero__media video', {
        scale: 1,
        duration: 1.8,
        ease: 'power2.out',
      }, 0);

      tl.to('.df-hero__eyebrow', {
        opacity: 1,
        y: 0,
        duration: 0.8,
      }, 0.4);

      // Split title words
      const titleWords = hero.querySelectorAll('.df-hero__title span');
      if (titleWords.length) {
        tl.to(titleWords, {
          opacity: 1,
          y: 0,
          duration: 0.9,
          stagger: 0.08,
          ease: 'power4.out',
        }, 0.5);
      }

      tl.to('.df-hero__subtitle', {
        opacity: 1,
        y: 0,
        duration: 0.8,
      }, 0.9);

      tl.to('.df-hero__actions', {
        opacity: 1,
        y: 0,
        duration: 0.8,
      }, 1.1);

      tl.to('.df-hero__scroll-indicator', {
        opacity: 1,
        duration: 1,
      }, 1.5);

      // Hero parallax on scroll
      gsap.to('.df-hero__media', {
        y: '20%',
        ease: 'none',
        scrollTrigger: {
          trigger: hero,
          start: 'top top',
          end: 'bottom top',
          scrub: 1,
        },
      });

      // Fade out hero content on scroll
      gsap.to('.df-hero__content', {
        opacity: 0,
        y: -60,
        ease: 'none',
        scrollTrigger: {
          trigger: hero,
          start: '60% top',
          end: 'bottom top',
          scrub: 1,
        },
      });
    }

    // ─── Generic [data-df-animate] elements ───
    document.querySelectorAll('[data-df-animate]').forEach(function (el) {
      var type = el.dataset.dfAnimate;
      var delay = parseFloat(el.dataset.dfDelay || '0');
      var props = { opacity: 1, duration: 0.8, delay: delay, ease: 'power3.out' };

      if (type === 'fade-up') props.y = 0;
      else if (type === 'fade-right') props.x = 0;
      else if (type === 'fade-left') props.x = 0;
      else if (type === 'scale-in') props.scale = 1;

      gsap.to(el, Object.assign(props, {
        scrollTrigger: {
          trigger: el,
          start: 'top 88%',
          toggleActions: 'play none none none',
        },
      }));
    });

    // ─── Bento Grid Items ───
    document.querySelectorAll('.df-bento__item').forEach(function (el, i) {
      gsap.from(el, {
        opacity: 0,
        y: 30,
        scale: 0.97,
        duration: 0.7,
        delay: i * 0.08,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: el,
          start: 'top 90%',
          toggleActions: 'play none none none',
        },
      });
    });

    // ─── Product Cards Stagger ───
    document.querySelectorAll('.df-product-card').forEach(function (el, i) {
      gsap.from(el, {
        opacity: 0,
        y: 24,
        duration: 0.5,
        delay: i * 0.06,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: el,
          start: 'top 92%',
          toggleActions: 'play none none none',
        },
      });
    });

    // ─── Category Cards ───
    document.querySelectorAll('.df-category-card').forEach(function (el, i) {
      gsap.from(el, {
        opacity: 0,
        y: 40,
        duration: 0.7,
        delay: i * 0.1,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: el,
          start: 'top 88%',
          toggleActions: 'play none none none',
        },
      });
    });

    // ─── Editorial Section Parallax ───
    document.querySelectorAll('.df-editorial__media img').forEach(function (img) {
      gsap.to(img, {
        y: '-8%',
        ease: 'none',
        scrollTrigger: {
          trigger: img.closest('.df-editorial'),
          start: 'top bottom',
          end: 'bottom top',
          scrub: 1,
        },
      });
    });

    // ─── Trust Items ───
    document.querySelectorAll('.df-trust__item').forEach(function (el, i) {
      gsap.from(el, {
        opacity: 0,
        y: 20,
        duration: 0.5,
        delay: i * 0.1,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: el,
          start: 'top 92%',
          toggleActions: 'play none none none',
        },
      });
    });

    // ─── Newsletter BG Text Parallax ───
    var bgText = document.querySelector('.df-newsletter__bg-text');
    if (bgText) {
      gsap.to(bgText, {
        x: '10%',
        ease: 'none',
        scrollTrigger: {
          trigger: bgText.closest('.df-newsletter'),
          start: 'top bottom',
          end: 'bottom top',
          scrub: 1,
        },
      });
    }

    // ─── Magnetic Button Effect ───
    document.querySelectorAll('.df-btn--primary').forEach(function (btn) {
      btn.addEventListener('mousemove', function (e) {
        var rect = btn.getBoundingClientRect();
        var x = e.clientX - rect.left - rect.width / 2;
        var y = e.clientY - rect.top - rect.height / 2;
        gsap.to(btn, { x: x * 0.2, y: y * 0.2, duration: 0.3, ease: 'power2.out' });
      });
      btn.addEventListener('mouseleave', function () {
        gsap.to(btn, { x: 0, y: 0, duration: 0.5, ease: 'elastic.out(1, 0.5)' });
      });
    });

    // ─── Header hide on scroll down, show on scroll up ───
    var headerGroup = document.getElementById('header-group');
    if (headerGroup) {
      var lastScrollY = 0;
      ScrollTrigger.create({
        start: 'top -100',
        onUpdate: function (self) {
          var direction = self.direction;
          if (direction === 1 && window.scrollY > 300) {
            gsap.to(headerGroup, { y: '-100%', duration: 0.4, ease: 'power2.inOut' });
          } else {
            gsap.to(headerGroup, { y: '0%', duration: 0.4, ease: 'power2.inOut' });
          }
        },
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    // GSAP might still be loading, wait a tick
    setTimeout(init, 100);
  }
})();
